import { DiscountBreakdownDialog } from '@/components/DiscountBreakdownDialog/DiscountBreakdownDialog'
import { DiscountTooltip } from '@/components/DiscountTooltip/DiscountTooltip'
import { useDiscountTooltipProps } from '@/components/DiscountTooltip/useDiscountTooltipProps'
import { BundleDiscountOfferPromotionTooltip } from '@/features/bundleDiscount/components/BundleDiscountOfferPromotionTooltip'
import { usePriceIntentValueOrThrow } from '@/features/priceCalculator/usePriceIntent'
import { type ProductOfferFragment } from '@/services/graphql/generated'
import { useShopSessionValueOrThrow } from '@/services/shopSession/ShopSessionContext'

export function DiscountHighlight({ selectedOffer }: { selectedOffer: ProductOfferFragment }) {
  const shopSession = useShopSessionValueOrThrow()
  const priceIntent = usePriceIntentValueOrThrow()

  const discountTooltipProps = useDiscountTooltipProps(
    selectedOffer,
    priceIntent.hasCollectedInsurelyData,
    shopSession.cart.redeemedCampaignV2 ?? undefined,
  )

  if (discountTooltipProps != null) {
    return (
      <DiscountTooltip
        {...discountTooltipProps}
        orientation="bottom"
        subtitle={
          discountTooltipProps.subtitle ?? (
            // 'key' is needed to avoid weird issues where dialog content flashes while closing
            <DiscountBreakdownDialog key={selectedOffer.id} offer={selectedOffer} priceIntent={priceIntent} />
          )
        }
      />
    )
  } else if (selectedOffer.bundleDiscount.isEligible) {
    return <BundleDiscountOfferPromotionTooltip offer={selectedOffer} orientation="bottom" />
  }

  return null
}
